// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/sweetalert/dist/sweetalert.css
// module id = 24
// module chunks = 0